import React, { useState } from 'react'
import { Marker, InfoWindow } from '@react-google-maps/api'
import mapIcon from 'assets/svg/map-icon.svg'
import verifiedCheck from 'assets/svg/verified.svg'
import { format } from 'date-fns'
import { getOrderUrl } from 'app/utils/order-ahead'
import env from 'env'

export default function EventMapMarker(props) {
  const { event, isActive, setIsActive } = props

  const canShowOrderUrl = env.ENABLE_ORDER_AHEAD && event.sleek_link

  return (
    <Marker
      position={{
        lat: event.address.location?.lat,
        lng: event.address.location?.lng,
      }}
      onClick={() => {
        if (setIsActive) {
          setIsActive(event.id)
        }
      }}
      icon={{
        url: mapIcon,
        scaledSize: {
          width: 50,
          height: 50,
        },
      }}
    >
      {isActive && (
        <InfoWindow
          position={{
            lat: event.address.location?.lat,
            lng: event.address.location?.lng,
          }}
          onCloseClick={() => {
            setIsActive(null)
          }}
        >
          <div className="md:flex">
            {event.caterer.photos[0] && (
              <div className="h-24 w-32 hidden md:block">
                <div
                  className="h-full bg-cover bg-center bg-no-repeat"
                  style={{
                    backgroundImage: `url('${event.caterer.photos[0].url}')`,
                  }}
                />
              </div>
            )}
            <div className="flex-1 flex flex-col pl-4 pt-1">
              <a
                href={`/${event.caterer.slug}/`}
                className={[
                  'flex items-start font-platform text-lg text-blue mb-2',
                  'hover:underline',
                ]}
              >
                {event.caterer.name}
              </a>
              <div className="font-light text-gray-900 leading-normal">
                <div className="whitespace-no-wrap">
                  {event.address.formatted}
                </div>
                <div className="">
                  <span>From </span>
                  <span className="font-bold">{format(event.start_date, 'M/d h:mm a')}</span>
                  <span> to </span>
                  <span className="font-bold">{format(event.end_date, 'M/d h:mm a')}</span>
                </div>
                <div className="mt-2 flex text-blue">
                  {canShowOrderUrl && (
                    <>
                      <a
                        href={getOrderUrl(event.sleek_link.stall_id, event)}
                        children="Order Ahead"
                        target="_blank"
                      />
                      <span className="px-1">
                        &#8226;
                      </span>
                    </>
                  )}
                  <a
                    href={`/${event.caterer.slug}/`}
                    children="View Menu"
                  />
                </div>
              </div>
            </div>
          </div>
        </InfoWindow>
      )}
    </Marker>
  )
}
